function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    text-align: center;\n    margin-bottom: 1.5rem;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    margin-bottom: 24px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n\n  .ant-typography {\n    font-size: 12px;\n    margin-top: 16px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "Unexpected error while sending reset password email."
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "Contact Support."
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "Please address the errors shown below"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "Forgot Your Password?"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "Enter the email address you use to log in and we'll email you instructions on how to reset your password."
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "Email Address"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "Email Address is required."
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "Invalid email address."
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "Sending Reset Instructions..."
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "Send Reset Instructions"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "Back to Login"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "Check Your Email"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "We have sent an email to ",
        " with instructions on how to reset your password. If you don't receive the email within a few minutes, please check your spam folder."
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "Back to Login Form"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "Need help? ",
        ""
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
import React, { useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { Button, Form as AntForm, Input, message, Typography, Space } from "antd";
import { t, jt } from "ttag";
import useTranslation from "../../../hooks/useTranslation";
import { SUPPORT_EMAIL } from "../../../services/support/types";
import Label from "../../Label";
import Layout from "../Layout";
var AntTitle = Typography.Title, Text = Typography.Text;
var useForm = AntForm.useForm;
var Title = styled(AntTitle)(_templateObject());
var Form = styled(AntForm)(_templateObject1());
var Field = styled(AntForm.Item)(_templateObject2());
var Help = styled.div(_templateObject3());
var ForgotPassword = function(param) {
    var forgotPasswordFn = param.forgotPasswordFn;
    var history = useHistory();
    var _useForm = _slicedToArray(useForm(), 1), form = _useForm[0];
    var validateFields = form.validateFields, getFieldValue = form.getFieldValue;
    var _useState = _slicedToArray(useState(false), 2), loading = _useState[0], setLoading = _useState[1];
    var _useState1 = _slicedToArray(useState(false), 2), sentEmail = _useState1[0], setSentEmail = _useState1[1];
    useTranslation();
    var onFinish = function() {
        var _ref = _asyncToGenerator(function() {
            var values, payload, e;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        return [
                            4,
                            validateFields()
                        ];
                    case 1:
                        values = _state.sent();
                        payload = {
                            email: values.email
                        };
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            forgotPasswordFn(payload)
                        ];
                    case 3:
                        _state.sent();
                        setSentEmail(true);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        e = _state.sent();
                        message.error(t(_templateObject4()));
                        return [
                            3,
                            5
                        ];
                    case 5:
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function onFinish() {
            return _ref.apply(this, arguments);
        };
    }();
    var emailBolded = /*#__PURE__*/ React.createElement(Text, {
        key: "email",
        strong: true
    }, getFieldValue("email"));
    var contactSupport = /*#__PURE__*/ React.createElement("a", {
        key: "supportEmail",
        href: "mailto:".concat(SUPPORT_EMAIL)
    }, t(_templateObject5()));
    return /*#__PURE__*/ React.createElement(Layout, null, !sentEmail && /*#__PURE__*/ React.createElement(Form, {
        form: form,
        layout: "vertical",
        hideRequiredMark: true,
        onFinish: onFinish,
        onFinishFailed: function() {
            return message.error(t(_templateObject6()));
        },
        initialValues: {
            email: ""
        }
    }, /*#__PURE__*/ React.createElement(Title, {
        level: 4
    }, t(_templateObject7())), /*#__PURE__*/ React.createElement(Text, {
        style: {
            marginBottom: "24px"
        }
    }, t(_templateObject8())), /*#__PURE__*/ React.createElement(Field, {
        label: /*#__PURE__*/ React.createElement(Label, {
            isRequired: true
        }, t(_templateObject9())),
        name: "email",
        rules: [
            {
                required: true,
                message: t(_templateObject10())
            },
            {
                type: "email",
                message: t(_templateObject11())
            }
        ]
    }, /*#__PURE__*/ React.createElement(Input, {
        "data-testid": "email"
    })), /*#__PURE__*/ React.createElement(Field, {
        shouldUpdate: true,
        noStyle: true
    }, function() {
        return /*#__PURE__*/ React.createElement(Button, {
            type: "primary",
            htmlType: "submit",
            loading: loading,
            disabled: loading || !getFieldValue("email"),
            style: {
                marginBottom: "16px"
            }
        }, loading ? t(_templateObject12()) : t(_templateObject13()));
    }), /*#__PURE__*/ React.createElement(Button, {
        onClick: function() {
            return history.replace("/");
        }
    }, t(_templateObject14()))), sentEmail && /*#__PURE__*/ React.createElement(Space, {
        direction: "vertical",
        size: "middle"
    }, /*#__PURE__*/ React.createElement(Title, {
        level: 4
    }, t(_templateObject15())), /*#__PURE__*/ React.createElement(Text, {
        style: {
            marginBottom: "24px"
        }
    }, jt(_templateObject16(), emailBolded)), /*#__PURE__*/ React.createElement(Button, {
        type: "primary",
        htmlType: "submit",
        onClick: function() {
            return history.replace("/");
        },
        style: {
            width: "100%"
        }
    }, t(_templateObject17())), /*#__PURE__*/ React.createElement(Help, null, /*#__PURE__*/ React.createElement(Text, null, jt(_templateObject18(), contactSupport)))));
};
export default ForgotPassword;
